import React from 'react'
import Head from 'next/head'

import {
  Hero,
  Trusted,
  Business,
  Services,
  Outcomes,
  CTA,
} from '@components/landing'

const Index = () => {
  return (
    <React.Fragment>
      <Head>
        <link rel='preload' as='image' href='/images/Landing_1.png' />
      </Head>

      <div className='Landing'>
        <Hero />
        <Trusted />
        <Business />
        <Services />
        <Outcomes />
        <CTA />
      </div>
    </React.Fragment>
  )
}

export default Index
